import classnames from 'clsx'
import type { FC } from 'react'

import MountPoints from 'shared/utils/mountPoints'

const QuerySuggestionsList: FC<{
  querySuggestions: string[]
  mountPoints: MountPoints
}> = ({ querySuggestions, mountPoints }) => {
  return (
    <>
      {querySuggestions.length > 0 && (
        <>
          {querySuggestions.map(querySuggestion => (
            <li
              key={querySuggestion}
              className={classnames(
                'o-SearchBox__search-suggest u-padding-xx-small--bottom'
              )}
            >
              <a
                href={mountPoints.getSearch({
                  internal: true,
                  banner: false,
                  query: querySuggestion,
                })}
                className="o-SearchBox__search-suggest__query-suggestion"
                data-clientside-hook="searchBox_autoSuggest_querySuggestion"
              >
                {querySuggestion}
              </a>
            </li>
          ))}
        </>
      )}
    </>
  )
}

export default QuerySuggestionsList
